import { Rectangle } from 'recharts';
import styled from 'styled-components';
import { Tooltip } from '@optimus-web/core';
import { COLOR_GRAY, COLOR_TEXT, EASING_MOVE, TRANSITION_DURATION } from '../../../components/commander-ui/constants';
import { COLOR_BAR_NORMAL, COLOR_BAR_OVERBOOKED } from './constants';
import { isOverbooked } from './utils';

export const getFillColor = (value: $TSFixMe) => (isOverbooked(value) ? COLOR_BAR_OVERBOOKED : COLOR_BAR_NORMAL);

export const TooltipedRectangleContainer = Tooltip(styled.g``);

export const RectangleElement = styled(Rectangle)`
    transition: fill ${TRANSITION_DURATION}ms ${EASING_MOVE};
`;

export const ContainerElement = styled.div`
    margin-top: 12px;
`;

export const TooltipElement = styled.div`
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    padding: 0;
`;

export const TooltipItemElement = styled.div`
    font-size: small;
    padding: 4px 12px;
    display: flex;
    flex-direction: row;
    color: ${(props) => props.color || COLOR_TEXT};
    align-items: center;
    opacity: ${(props) => (props as $TSFixMe).opacity};
`;

export const TooltipItemNameElement = styled.div`
    flex-grow: 1;
    padding-right: 12px;
    display: block;
`;

export const TooltipLabelElement = styled.div`
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    padding: 12px;
    font-weight: 600;
`;

export const TooltipMarkElement = styled.div`
    display: block;
    margin-right: 16px;
    width: 1em;
    height: 1em;
    background: ${(props) => props.color};
`;

export const LegendElement = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 12px;
`;

export const DividerElement = styled.div`
    width: 1px;
    min-height: 100%;
    margin-right: 12px;
    background: ${COLOR_GRAY};
`;
